'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = simple;

var _common = require('./common');

// @param {Number=datum.length} setSize
function simple() {
  var _check = _common.check.apply(undefined, arguments);

  var _check2 = _slicedToArray(_check, 2);

  var datum = _check2[0];
  var size = _check2[1];


  return datum.reduce(function (prev, current, index, array) {
    if (index < size - 1) {
      prev.sum += current;
    } else if (index === size - 1) {
      prev.sum += current;
      prev.ma.push(prev.sum / size);
    } else {
      prev.sum += current - array[index - size];
      prev.ma.push(prev.sum / size);
    }

    return prev;
  }, {
    sum: 0,
    ma: []
  }).ma;
}